module.exports = __webpack_public_path__ + "media/images/cv/screen_khsm-0d97725f95f40f76459833b109330b07.jpg";